<template>
    <div>
        <h2>Add new incident</h2>
        <hr />
        <div class="bootstrap-iso">
            <div class="container-fluid">
                <div class="row">
                    <div class="col-md-12 col-md-12 col-sm-12 col-xs-12">
                        <form>
                            <div v-if="!type" class="form-group">
                                <label class="control-label" for="quickTemplates">
                                    Quick Templates
                                </label>
                                <div class="row">
                                    <QuickTemplateCA
                                        v-if="showCATemplates"
                                        @template-selected="applyTemplate"
                                        @template-cleared="clearTemplate"
                                    />
                                    <QuickTemplateCE
                                        v-if="showCETemplates"
                                        @template-selected="applyTemplate"
                                        @template-cleared="clearTemplate"
                                    />
                                </div>
                            </div>
                            <hr v-if="!type" />
                            <div class="form-group">
                                <div class="row">
                                    <div class="col-lg-4 col-md-4 col-sm-12 col-xs-12">
                                        <label
                                            class="control-label"
                                            for="componentType"
                                        >Affected Component</label>
                                        <br />
                                        <b-form-select
                                            v-model="selectedComponent"
                                            :options="availableComponents"
                                        ></b-form-select>
                                    </div>
                                    <div class="col-lg-4 col-md-4 col-sm-12 col-xs-12">
                                        <label class="control-label" for="type">Incident Type</label>
                                        <br />
                                        <b-form-select
                                            v-model="selectedIncidentType"
                                            :options="availableIncidentTypes"
                                        ></b-form-select>
                                    </div>
                                    <div class="col-lg-4 col-md-4 col-sm-12 col-xs-12">
                                        <label class="control-label" for="status">Component Status</label>
                                        <br />
                                        <b-form-select
                                            v-model="selectedStatus"
                                            :options="availableStatuses"
                                        ></b-form-select>
                                    </div>
                                </div>
                            </div>
                            <div class="form-group">
                                <div class="row">
                                    <div class="col-lg-6 col-md-12 col-sm-12 col-xs-12">
                                        <label class="control-label" for="startDate">
                                            Start date (UTC)
                                            <span class="asteriskField">*</span>
                                        </label>
                                        <div class="input-group date">
                                            <datetime
                                                v-model="incident.startDate"
                                                placeholder="Select start date in UTC"
                                                type="datetime"
                                                :format="dateTimeFormat"
                                                zone="UTC"
                                                input-class="form-control"
                                            ></datetime>
                                        </div>
                                    </div>
                                    <div class="col-lg-6 col-md-12 col-sm-12 col-xs-12">
                                        <label class="control-label" for="endDate">End date (UTC)</label>
                                        <div class="input-group date">
                                            <datetime
                                                v-model="incident.endDate"
                                                placeholder="Select end date in UTC"
                                                type="datetime"
                                                :format="dateTimeFormat"
                                                zone="UTC"
                                                input-class="form-control"
                                            ></datetime>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="form-group">
                                <div class="row">
                                    <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12">
                                        <label
                                            class="control-label"
                                            for="sendEmail"
                                        >Notify subscribed users of new incident</label>
                                    </div>
                                    <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12">
                                        <b-form-radio-group
                                            v-model="selectedSendNotification"
                                            :options="availableSendNotifitionOptions"
                                            name="radio-inline"
                                            stacked
                                            plain
                                            class="send-notification-group"
                                        ></b-form-radio-group>
                                    </div>
                                </div>
                            </div>
                            <div class="form-group">
                                <label class="control-label requiredField" for="message">
                                    Message
                                    <span class="asteriskField">*</span>
                                </label>
                                <textarea
                                    class="form-control"
                                    cols="40"
                                    name="message"
                                    placeholder="Message..."
                                    rows="10"
                                    v-model="incident.message"
                                ></textarea>
                            </div>
                            <hr />
                            <div class="form-group">
                                <div class="pull-left">
                                    <button
                                        class="btn btn-outline btn-primary btn-preview"
                                        v-on:click.prevent="isPreviewVisible = !isPreviewVisible"
                                    >
                                        <span v-if="!isPreviewVisible">Show email preview</span>
                                        <span v-else>Hide email preview</span>
                                    </button>
                                </div>
                                <div class="pull-right">
                                    <button
                                        class="btn btn-outline btn-success"
                                        v-on:click.prevent="submit"
                                    >Submit</button>
                                </div>
                            </div>
                        </form>
                    </div>
                </div>
                <div class="row row--preview" v-if="isPreviewVisible">
                    <div class="col-md-12 col-md-12 col-sm-12 col-xs-12 ml-1">
                        <iframe class="preview" :src="previewUrl"></iframe>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex"
import { Datetime } from "vue-datetime"
import moment from "moment"
import { NotificationsMixin } from "./mixin"
import QuickTemplateCA from "./QuickTemplateCA"
import QuickTemplateCE from "./QuickTemplateCE"

export default {
    name: "NewIncident",
    props: {
        type: { default: null }
    },
    mixins: [NotificationsMixin],
    components: {
        datetime: Datetime,
        QuickTemplateCA,
        QuickTemplateCE
    },
    data() {
        return {
            isLoading: false,
            isPreviewVisible: false,
            timeout: null,
            previewUrl: null,
            dateTimeFormat: {
                year: "numeric",
                month: "long",
                day: "numeric",
                hour: "numeric",
                minute: "2-digit",
                timeZoneName: "short"
            },
            incident: null,
            availableIncidentTypes: [
                { value: "1", text: "Scheduled" },
                { value: "0", text: "Unscheduled" }
            ],
            availableStatuses: [
                { value: "1", text: "Down" },
                { value: "0", text: "Up" }
            ],
            availableSendNotifitionOptions: [
                { value: "1", text: "Send notification" },
                { value: "0", text: "Don't send notification" }
            ]
        }
    },
    computed: {
        ...mapGetters({
            components: "getComponents",
            baseApiUrl: "getBaseApiUrl",
            emailUseTemplate: "getEmailUseTemplate"
        }),
        showCATemplates() {
            const platform = this.emailUseTemplate
            return !platform || String(platform).toLowerCase() === 'ca'
        },
        showCETemplates() {
            const platform = this.emailUseTemplate
            return !platform || String(platform).toLowerCase() === 'ce'
        },
        availableComponents() {
            return this.components.map(component => {
                return {
                    ...component,
                    value: component.id,
                    text: component.name
                }
            })
        },
        selectedComponent: {
            get() {
                return this.incident.componentId
            },
            set(componentId) {
                this.incident.componentId = componentId
            }
        },
        selectedIncidentType: {
            get() {
                return this.incident.isScheduled
            },
            set(isScheduled) {
                this.incident.isScheduled = isScheduled
            }
        },
        selectedStatus: {
            get() {
                return this.incident.isComponentDown
            },
            set(isComponentDown) {
                this.incident.isComponentDown = isComponentDown
            }
        },
        selectedSendNotification: {
            get() {
                return this.incident.sendEmail
            },
            set(sendEmail) {
                this.incident.sendEmail = sendEmail
            }
        }
    },
    created() {
        this.incident = this.initIncidentData()
    },
    methods: {
        ...mapActions({
            createNewIncident: "createNewIncident"
        }),
        submit() {
            if (this.isIncidentValid()) {
                this.createNewIncident(this.incident).then(
                    response => {
                        this.showSuccessMsg({
                            title: "Success.",
                            message: "Incident succesfully created."
                        })
                        this.$router.push({ name: "Index" })
                    },
                    error => {
                        this.showErrorMsg({
                            title: "Error creating incident!",
                            message: error
                        })
                    }
                )
            }
        },
        isIncidentValid() {
            if (!this.incident.message && this.incident.message !== "") {
                this.showErrorMsg({
                    title: "Message is required!",
                    message: ""
                })
                return false
            } else if (this.incident.endDate) {
                if (!(this.incident.startDate < this.incident.endDate)) {
                    this.showErrorMsg({
                        title: "Incident end date must be after start date!",
                        message: ""
                    })
                    return false
                }
            }

            return true
        },
        defaultStartDate(isSaturday = false) {
            let date = new Date()

            if (isSaturday) {
                date.setDate(date.getDate() + ((13 - date.getDay()) % 7))
            }

            date.setUTCSeconds(0)
            date.setUTCMinutes(0)
            date.setUTCHours(8)

            return date.toISOString()
        },
        nextSaturdayDate() {
            let today = new Date()
            today.setUTCSeconds(0)
            today.setUTCMinutes(0)
            today.setUTCHours(8)
            return today.toISOString()
        },
        initIncidentData() {
            let defaultComponent = this.components[0]

            let incident = {
                componentId: defaultComponent.id,
                startDate: this.defaultStartDate(),
                endDate: null,
                isScheduled: "1",
                isComponentDown: "0",
                message: "",
                sendEmail: "1"
            }

            if (this.type) {
                let startDate = this.defaultStartDate(true)

                incident = {
                    componentId: defaultComponent.id,
                    startDate: startDate,
                    endDate: null,
                    isScheduled: "1",
                    isComponentDown: "0",
                    message: `On Saturday, ${moment
                        .utc(startDate)
                        .format("MMMM Do YYYY")} at ${moment
                        .utc(startDate)
                        .format(
                            "hA"
                        )} UTC, we will be performing a scheduled platform upgrade. The maintenance is expected to last up to 1 hour during which access to Builder, Dashboard and Analytics will be unavailable. Ad serving will not be affected. We are sorry for the inconvenience. Please contact support with any questions you may have.`,
                    sendEmail: "1"
                }
            }

            return incident
        },
        applyTemplate(templateData) {
            this.incident.message = templateData.message
            Object.assign(this.incident, templateData.config)
            this.incident.startDate = new Date().toISOString()
            this.incident.endDate = null
            this.setComponentByName(templateData.component)
        },
        clearTemplate() {
            this.incident = this.initIncidentData()
        },
        setComponentByName(componentName) {
            const component = this.components.find(c => c.name === componentName)
            this.incident.componentId = (component && component.id) || (this.components[0] && this.components[0].id)
        },
        updatePreview() {
            let selectedComponentName = this.components.filter(component => {
                return component.id === this.incident.componentId
            })[0].name

            this.previewUrl =
                this.baseApiUrl +
                "preview?message=" +
                encodeURI(this.incident.message) +
                "&component=" +
                selectedComponentName +
                "&isScheduled=" + this.incident.isScheduled
        }
    },
    watch: {
        incident: {
            handler: function(newVal, oldVal) {
                clearTimeout(this.timeout)

                let that = this
                this.timeout = setTimeout(function() {
                    that.updatePreview()
                }, 500)
            },
            deep: true
        },
        type: function(newVal, oldVal) {
            this.incident = this.initIncidentData()
        }
    }
}
</script>


<style>
.form-check-description {
    padding-left: 5px;
    font-weight: 500;
}
</style>

<style scoped>
.input-group {
    width: 100%;
}

.preview {
    width: 100%;
    height: 450px;
}

.row--preview {
    padding-top: 30px;
}

.btn--checkbox {
    width: 120px;
}

.btn-preview {
    width: 150px;
}

.send-notification-group:focus {
    outline: none;
}

.form-check-description {
    padding-left: 5px;
}
</style>



// WEBPACK FOOTER //
// src/components/NewIncident.vue